import type { Provider } from '../types/api';
import airtelLogo from '../assets/networks/airtel.svg';
import mtnLogo from '../assets/networks/mtn-yellow.png';

interface NetworkBrandProps {
  provider: Provider;
  compact?: boolean;
  className?: string;
}

export const networkName = (provider: Provider) => provider === 'mtn' ? 'MTN MoMo' : 'Airtel Money';

export function NetworkBrand({ provider, compact = false, className = '' }: NetworkBrandProps) {
  const name = networkName(provider);

  return (
    <span className={`network-brand network-brand-${provider} ${compact ? 'network-brand-compact' : ''} ${className}`.trim()} aria-label={name}>
      <span className="network-brand-logo" aria-hidden="true">
        <img src={provider === 'mtn' ? mtnLogo : airtelLogo} alt="" />
      </span>
      {!compact && <span aria-hidden="true">{name}</span>}
    </span>
  );
}
